import type { ReactNode } from 'react';

// Card de pipe da seleção da Agronomia — mesmo padrão dos StatCards de destaque
// do CRM: 92×88, alinhado à esquerda, icon box 27×27 coral sólido + ícone branco.
export function AgroPipeCard({
  titulo,
  icone,
  onClick,
}: {
  titulo: string;
  icone: ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-[88px] w-[92px] flex-col items-start gap-[7px] rounded-[7px] border border-border bg-surface p-[9px] text-left transition-colors hover:bg-[var(--pipe-active)] dark:border-transparent"
    >
      <span className="flex h-[27px] w-[27px] items-center justify-center rounded-[7px] bg-[var(--accent)] text-[var(--on-solid)]">
        {icone}
      </span>
      <span className="text-[13px] font-semibold leading-tight text-text">{titulo}</span>
    </button>
  );
}
